import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { SKIP_TOKEN } from '@shared/data-access/data-access-authentication';
import { map, Observable } from 'rxjs';
import { Article } from '../model/article.model';
import { CMSPaginatedResponse, CMSResponse } from '../model/cms-response.model';
import { ExternalResource } from '../model/external-resource.model';
import { SpotifyLink } from '../model/spotify-link.model';

@Injectable()
export class KnowledgeService {
  private readonly http = inject(HttpClient);

  getArticles(): Observable<CMSPaginatedResponse<Article>> {
    const params = new HttpParams().set('populate', '*');

    return this.http
      .get<CMSPaginatedResponse<Article>>(`${environment.headlessCms.baseUrl}/api/articles`, {
        headers: {
          Authorization: `Bearer ${environment.headlessCms.apiKey}`,
        },
        context: new HttpContext().set(SKIP_TOKEN, true),
        params,
      })
      .pipe(
        map((response) => ({
          ...response,
          data: response.data.filter((article) => article.visible),
        })),
      );
  }

  getArticleDetails(slug: string): Observable<CMSResponse<Article>> {
    return this.http.get<CMSResponse<Article>>(`${environment.headlessCms.baseUrl}/api/articles/${slug}`, {
      headers: {
        Authorization: `Bearer ${environment.headlessCms.apiKey}`,
      },
      context: new HttpContext().set(SKIP_TOKEN, true),
    });
  }

  getSpotifyLinks(): Observable<CMSPaginatedResponse<SpotifyLink>> {
    return this.http.get<CMSPaginatedResponse<SpotifyLink>>(`${environment.headlessCms.baseUrl}/api/spotifies`, {
      headers: {
        Authorization: `Bearer ${environment.headlessCms.apiKey}`,
      },
      context: new HttpContext().set(SKIP_TOKEN, true),
    });
  }

  getExternalResources(): Observable<CMSPaginatedResponse<ExternalResource>> {
    const params = new HttpParams().set('populate', '*');

    return this.http.get<CMSPaginatedResponse<ExternalResource>>(`${environment.headlessCms.baseUrl}/api/resources`, {
      headers: {
        Authorization: `Bearer ${environment.headlessCms.apiKey}`,
      },
      context: new HttpContext().set(SKIP_TOKEN, true),
      params,
    });
  }
}
